/* eslint-disable */
window.addEventListener('load', () => {
    let timer_search = null,
        timer_hide = null,
        rest_route = `/wp-json/custom/search?s=`;
    const search_container = document.querySelector('#search-form'),
        search_results = search_container.querySelector('.search__results'),

        search_input = search_container.querySelector('#search'),
        search_openner = document.querySelector('.btn-search');


    // Make input focused after openning search modal
    search_openner && search_openner.addEventListener('click', () => {
        search_input.focus();
    });

    // Start searching items after user finishes typing
    search_input.addEventListener('keyup', () => {
        // clear timeout if user enters another character before function executes
        clearTimeout(timer_search);
        const searched_item = search_input.value;
        rest_route = `/wp-json/custom/search?s=${ searched_item }`;

        // Do search if user enters more than 3 characters
        if ( searched_item.length <= 2 ) {
            search_results.classList.remove('show');
            search_results.innerHTML = '';
            return;
        }

        // Start searching after user finishes typing after 350ms
        timer_search = setTimeout(() => {
            search_container.classList.add('searching');
            fetch(rest_route)
                .then(response => response.json())
                .then(data => {
                    let html = '';
                    if ( typeof data != 'string' ) {
                        data.posts.forEach(post => {
                            const { link, image, title, has_video } = post,
                                post_image = image ? `<a href="${ link }" class="post__image">${ has_video }<picture>${ image }</picture></a>` : '';

                            html += `
                            <div class="post post__card post__card--blue">
                                <div class="wrapper">
                                    ${ post_image }
                                    <div class="post__content">
                                        <h2 class="post__title">
                                            <a href="${ link }">${ title }</a>
                                        </h2>
                                    </div>
                                </div>
                            </div>
                            `;
                        });
                        html += `<button type="submit" class="btn search-link"><span class="icon"><svg viewBox="0 0 48 34" width="48" height="34">
                        <path fill="#fff" d="M0,13.4h34.8l0.1-0.2l-7.7-7.5L32.1,1L48,17L32.1,33l-4.7-4.7l7.8-7.5l-0.2-0.4H0V13.4z" /></svg>
                        </span><span class="search-text">${ data.button_label }</span></button>`;
                    } else {
                        html += `<span class="searched-post no-posts">${ data }</span>`;
                    }
                    search_results.innerHTML = html;
                    search_results.classList.add('show');
                    search_container.classList.remove('searching');

                })
                .catch(err => {
                    search_container.classList.remove('searching');
                    console.error('Error:', err);
                });
        }, 350);
    });

    if ( window.matchMedia('(hover: hover)').matches ) {
        // Hide search__results after focus is removed from input after 150ms
        search_input.addEventListener('blur', () => {
            timer_hide = setTimeout(() => {
                search_results.classList.remove('show');
            }, 150);
        });

        // When input gets focus clear timeout from hiding search__results and
        // if search__results are not empty show them otherwise stay hidden
        search_input.addEventListener('focus', () => {
            clearTimeout(timer_hide);
            if ( search_results.textContent !== '' ) {
                search_results.classList.add('show');
            }
        });
    }
});



// WEBPACK FOOTER //
// ./scripts/modules/search.js